import { render, staticRenderFns } from "./ChangeLogModal.vue?vue&type=template&id=799e921f&scoped=true"
import script from "./ChangeLogModal.vue?vue&type=script&lang=js"
export * from "./ChangeLogModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogModal.vue?vue&type=style&index=0&id=799e921f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e921f",
  null
  
)

export default component.exports